import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { customTableStylesReport, fallbackIfEmpty } from "utils/Utils";
import styles from "containers/Reports/ReportsLearningTraining/styles.module.scss";

const Table = ({ data, loading, actionFilter, totalRecords }) => {
  const columns = [
    {
      name: "Nome do treinamento",
      selector: "Nome do treinamento",
      sortable: true,
      center: false,
      wrap: true,
      width: "320px",
      style: { textAlign: "left" },
      cell: (d) => fallbackIfEmpty(d["Nome do treinamento"]),
    },
    {
      name: "Título da avaliação",
      selector: "Título da avaliação",
      sortable: true,
      center: false,
      wrap: true,
      width: "320px",
      style: { textAlign: "left" },
      cell: (d) => fallbackIfEmpty(d["Título da avaliação"]),
    },
    {
      name: "Média da avaliação (base 10)",
      selector: "Média da avaliação",
      sortable: true,
      center: true,
      wrap: true,
      width: "100px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Média da avaliação"]),
    },
    {
      name: "Enunciado da questão",
      selector: "Enunciado da questão",
      sortable: true,
      center: false,
      wrap: true,
      width: "400px",
      style: { textAlign: "left" },
      cell: (d) => fallbackIfEmpty(d["Enunciado da questão"]),
    },
    {
      name: "Tipo de questão",
      selector: "Tipo de Questão",
      sortable: true,
      center: false,
      wrap: true,
      width: "120px",
      style: { textAlign: "left" },
      cell: (d) => fallbackIfEmpty(d["Tipo de Questão"]),
    },
    {
      name: "Enunciado da linha",
      selector: "Enunciado da Linha",
      sortable: true,
      center: false,
      wrap: true,
      width: "280px",
      style: { textAlign: "left" },
      cell: (d) => fallbackIfEmpty(d["Enunciado da Linha"]),
    },
    {
      name: "Qtd. Alternativas",
      selector: "Qtd. de Alternativas",
      sortable: true,
      center: true,
      wrap: true,
      width: "100px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Qtd. de Alternativas"]),
    },
    {
      name: "Qtd. de respondentes da questão",
      selector: "Qtd. de Respondentes da questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "100px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Qtd. de Respondentes da questão"]),
    },
    {
      name: "Média da questão",
      selector: "Média da questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "100px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Média da questão"]),
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Registros por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * data.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => (
    <div className="tela-login-loading">
      <div className="loader-container" style={{ margin: "300px 0" }}>
        <div
          style={{
            position: "initial",
            margin: "initial",
          }}
          className="loader loader-center loader-big"
        ></div>
        <span
          style={{
            marginTop: 10,
            fontSize: 20,
          }}
        >
          Carregando dados...
        </span>
      </div>
    </div>
  );

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={true}
      export={false}
    >
      <DataTable
        columns={columns}
        data={data}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
